export default (graphQLError) => {
  return graphQLError?.graphQLErrors?.[0]?.message;
};
